var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpediaFun = function SvgExpediaFun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.667v4.166h-1.666v-4.166a9.168 9.168 0 0 1 5.372-8.347l.69 1.517A7.502 7.502 0 0 0 15 14.667Zm-8.333 0v4.166H5v-4.166a7.502 7.502 0 0 0-4.396-6.83l.69-1.517a9.168 9.168 0 0 1 5.373 8.347ZM10 10.5a4.167 4.167 0 1 1 0-8.333 4.167 4.167 0 0 1 0 8.333Zm0-1.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "#000"
  })));
};
export default SvgExpediaFun;